/* Dry Eye Rescue - Learning Center video band (7 September 2026).
   Click-to-play for der-learn-video.liquid: the section ships a poster image and
   this swaps in the Wistia iframe on the first click, so the third-party player
   never loads for visitors who do not press play. Re-inits after a theme editor
   section reload. */
(function () {
  function mount(el) {
    if (el.dataset.dlWistiaReady === '1') return;
    el.dataset.dlWistiaReady = '1';
    var btn = el.querySelector('.dl-video__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = el.getAttribute('data-dl-wistia');
      if (!id) return;
      var label = btn.getAttribute('aria-label') || 'Video';
      var frame = document.createElement('div');
      frame.className = 'dl-video__frame';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://fast.wistia.net/embed/iframe/' + encodeURIComponent(id) + '?autoPlay=1&videoFoam=true';
      iframe.title = label;
      iframe.setAttribute('allow', 'autoplay; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('scrolling', 'no');
      frame.appendChild(iframe);
      el.innerHTML = '';
      el.appendChild(frame);
      el.classList.add('is-playing');
    });
  }
  function init(root) {
    (root || document).querySelectorAll('[data-dl-wistia]').forEach(mount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
